<div class="sidebar" [ngStyle]="{
  'background-color': settingsData?.space_bg_primary_color,
  'color': settingsData?.space_font_primary_color,
  'font-family': settingsData?.font_family
}">
  <div class="sidebar-header" [ngStyle]="{ '--scroll-color': settingsData?.space_button_secondary_color || '#888' }">
    <div class="logo" *ngIf="org_info">
      <img *ngIf="org_info" [src]="org_info" alt="Logo" class="brand-logo" />
    </div>

    <!-- Tabs for Affiliate Role -->
    <ng-container *ngIf="isTeamMember">
      <div class="tabs" [ngStyle]="{
        'background-color': settingsData?.space_font_primary_color
      }">
        <button class="tab-button" [ngStyle]="{
          'background-color': activeTab === 'private' ? settingsData?.space_button_secondary_color : settingsData?.space_button_primary_color,
          'color': activeTab === 'private' ? settingsData?.space_button_font_secondary_color : settingsData?.space_button_font_primary_color,
          'font-family': settingsData?.font_family
        }" (click)="switchTab('private')">
          Private
        </button>

        <button class="tab-button" [ngStyle]="{
          'background-color': activeTab === 'public' ? settingsData?.space_button_secondary_color : settingsData?.space_button_primary_color,
          'color': activeTab === 'public' ? settingsData?.space_button_font_secondary_color : settingsData?.space_button_font_primary_color,
          'font-family': settingsData?.font_family
        }" (click)="switchTab('public')">
          Public
        </button>
        <!-- <button class="tab-button" [ngStyle]="{
          'background-color': activeTab === 'private' ? settingsData?.form_bg_secondary_color : settingsData?.bg_primary_color,
          'color': activeTab === 'private'
            ? (settingsData?.form_bg_secondary_color === settingsData?.bg_primary_color
                ? settingsData?.form_bg_secondary_color
                : settingsData?.form_font_primary_color)
            : (settingsData?.bg_primary_color === settingsData?.bg_primary_color
                ? settingsData?.form_bg_secondary_color
                : settingsData?.form_font_primary_color)
        }" (click)="switchTab('public')">
          Public
        </button>
        <!-- <button class="tab-button" [ngStyle]="{
          'background-color': activeTab === 'private' ? settingsData?.form_bg_secondary_color : settingsData?.bg_primary_color,
          'color': activeTab === 'private'
            ? (settingsData?.form_bg_secondary_color === settingsData?.bg_primary_color
                ? settingsData?.form_bg_secondary_color
                : settingsData?.form_font_primary_color)
            : (settingsData?.bg_primary_color === settingsData?.bg_primary_color
                ? settingsData?.form_bg_secondary_color
                : settingsData?.form_font_primary_color)
        }" (click)="switchTab('private')">
          Private
        </button>

        <button class="tab-button" [ngStyle]="{
          'background-color': activeTab === 'public' ? settingsData?.form_bg_secondary_color : settingsData?.bg_primary_color,
          'color': activeTab === 'public'
            ? (settingsData?.form_bg_secondary_color === settingsData?.bg_primary_color
                ? settingsData?.form_bg_secondary_color
                : settingsData?.form_font_primary_color)
            : (settingsData?.bg_primary_color === settingsData?.bg_primary_color
                ? settingsData?.form_bg_secondary_color
                : settingsData?.form_font_primary_color)
        }" (click)="switchTab('public')">
          Public
        </button> -->
      </div>
    </ng-container>



    <!-- Search -->
    <div class="search-box dynamic-font" [ngStyle]="{
    'border': settingsData?.space_font_primary_color ? '1px solid ' +  settingsData?.space_font_primary_color : '1px solid ' + settingsData?.space_font_primary_color,
    'color': settingsData?.space_font_primary_color
  }">
      <!-- <img src="assets/search-icon.png" alt="Search" class="search-icon pr-2"  [style.filter]="getIconFilter(settingsData?.space_font_primary_color)"> -->
      <i class="fa fa-search pr-10 pl-2" aria-hidden="true" [ngStyle]="{
        'color': settingsData?.space_font_primary_color,
      }"></i>
      <input  class="search-input1 dynamic-font" [ngStyle]="{'color':settingsData?.space_font_primary_color, '--placeholder-color': settingsData?.space_font_primary_color}"  type="text" placeholder="Search..." [(ngModel)]="searchQuery" (keyup.enter)="CommunityChannelSearch()" (input)="onTypeSearch($event)">
    </div>

    <!-- Group filter -->
    <app-filter-dropdown *ngIf="groupsList?.length && !isGroupScoped"
        icon="fa-users" [label]="groupsLabel" [allLabel]="'All ' + groupsLabel + 's'"
        [selectedLabel]="selectedGroupName"
        [options]="groupsList | filter: groupSearchText:'name'"
        [displayFn]="groupDisplayFn"
        [searchable]="true" searchPlaceholder="Search group..."
        [searchText]="groupSearchText" (searchTextChange)="groupSearchText = $event"
        (optionSelect)="selectGroup($event)">
    </app-filter-dropdown>

    <!-- Add Channel -->
    <div class="addbutton" *ngIf="activeTab !== 'private'">
      <div class="pointer add-channel mb-10" (click)="addChannel()">
        <i [ngStyle]="{
        'color':settingsData?.space_font_primary_color
      }" class="fa fa-plus mr-5 fs-14 plus-icon"></i>
        <span class="dynamic-font">Add Space</span>
      </div>
    </div>

    <div class="horizontal-line" [ngStyle]="{ 'background-color': settingsData?.space_font_primary_color }"></div>

    <!-- Accordion Menus -->
    <div class="menu-section" *ngFor="let section of getVisibleSections()">
      <!-- Check if the section has channels -->
      <div *ngIf="getSectionChannels(section)">
        <div class="accordion-header" (click)="toggleAccordion(section)">
          <span class="mb-10 dynamic-font">
            <img *ngIf="section !== 'My Spaces'" [src]="getSectionIcon(section)" class="sidenav-image"  [style.filter]="getIconFilter()"/>
            {{ (section === 'Channels' ? 'Channels' : section) | titlecase }}
          </span>
          <i class="fa" [ngClass]="accordion[section] ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
        </div>

        <ul *ngIf="accordion[section] && activeTab !== 'private'">
          <ng-container *ngFor="let channel of getSectionChannels(section)
            | slice:0:(section === 'trending' && !searchQuery ? 5 : undefined)">
            <li *ngIf="matchesTab(channel) && matchesSearch(channel)"
              (click)="channel.dataStatus === 'A' && navigateToCommunity(channel.channelId || channel.name,channel)"
              [ngClass]="{ 'disabled': channel.dataStatus === 'P' }"
              class="mb-10 public channel-item"
              [style.padding-left]="'8px'"
              [style.padding-right]="'8px'">
              <div class="channel-content" [ngStyle]="{
                'color': (channel.channelId || channel.name) === activeChannel 
                  ? (settingsData?.space_button_font_secondary_color) 
                  : settingsData?.space_font_primary_color,
                'font-size': settingsData?.fs_sentence,
                'background-color': (channel.channelId || channel.name) === activeChannel 
                  ? (settingsData?.space_button_secondary_color) 
                  : settingsData?.space_bg_primary_color,
                'border-radius': '6px',
                'padding': '4px 8px',
                'display': 'flex',
                'align-items': 'center',
                'justify-content': 'space-between',
                'width': '100%',
                'box-sizing': 'border-box',
                'min-height': '32px'
              }">
                <span class="channel-name dynamic-font" [ngStyle]="{
                  'font-weight': (channel.channelId || channel.name) === activeChannel ? 'bold' : 'normal',
                  'white-space': 'nowrap',
                  'overflow': 'hidden',
                  'text-overflow': 'ellipsis',
                  'flex': '1',
                  'min-width': '0'
                }">
                  {{ channel.channelName || channel.name }}
                  <ng-container *ngIf="channel.dataStatus === 'P'">
                    <i class="fa fa-info-circle ml-1"
                        matTooltip="Request Pending"
                        [matTooltipClass]="'custom-tooltip'"
                        [matTooltipStyle]="{ 
                          'background-color': settingsData?.space_button_secondary_color,
                          'color': settingsData?.space_button_font_secondary_color ,
                          'font-family': settingsData?.font_family
                        }"
                        aria-hidden="true">
                    </i>
                  </ng-container>
                </span>

                <span class="channel-meta" style="display: flex; align-items: center; gap: 8px; margin-left: 8px;">
                  <span class="unread-count fs-13 dynamic-font" [ngStyle]="{
                    'background-color': (channel.channelId || channel.name) === activeChannel
                      ? settingsData?.space_button_secondary_color
                      : settingsData?.space_bg_primary_color,
                    'color': (channel.channelId || channel.name) === activeChannel
                      ? settingsData?.space_button_font_secondary_color
                      : settingsData?.space_font_primary_color,
                    'padding': '2px 6px',
                    'border-radius': '10px',
                    'min-width': '20px',
                    'text-align': 'center',
                    'line-height': '1.2',
                    'flex-shrink': '0'
                  }" *ngIf="unreadCount[channel?.channelUrl] > 0  && section !== 'trending'">
                    {{ unreadCount[channel?.channelUrl] > 99 ? '99+' : unreadCount[channel?.channelUrl] }}
                  </span>
                  <span *ngIf="section === 'trending' && channel.members > 0" class="members" style="white-space: nowrap; flex-shrink: 0;">
                    ({{ channel.members }} {{ channel.members > 1 ? 'Members' : 'Member' }})
                  </span>
                </span>
              </div>
            </li>
          </ng-container>
        </ul>

        <ul *ngIf="accordion[section] && activeTab === 'private'">
          <ng-container *ngFor="let team of getSectionChannels(section)">
            <li *ngIf="team.teamName !== 'Main' && team.teamId" class="team-header accordion-header dynamic-font" [ngStyle]="{
              'color': settingsData?.space_font_primary_color,
              'font-size': settingsData?.fs_sentence,
              'font-weight': 'bold',
              'padding': '10px 0'
            }" (click)="toggleTeamAccordion(team)">
              {{ team.teamName }}
              <i class="fa" [ngClass]="team.expanded ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
            </li>
            <!-- Team Channels -->
            <ng-container *ngIf="team.expanded">
              <ng-container *ngFor="let channel of team.channels">
                <li *ngIf="matchesTab(channel) && matchesSearch(channel)"
                  (click)="navigateToCommunity(channel.channelId || channel.name,channel)"
                  [class.active]="(channel.channelId || channel.name) === activeChannel" class="mb-10 private dynamic-font"
                  [ngClass]="{ 'ml-15': team.teamName !== 'Main' && team.teamId }" [ngStyle]="{
                  'color':  (channel.channelId || channel.name) === activeChannel ?settingsData?.space_button_font_secondary_color :settingsData?.space_font_primary_color,
                  'font-size': settingsData?.fs_sentence,
                  'background-color': (channel.channelId || channel.name) === activeChannel ? (settingsData?.space_button_secondary_color ? settingsData?.space_button_secondary_color : settingsData?.space_bg_primary_color) : 'transparent',
                  'font-weight': (channel.channelId || channel.name) === activeChannel ? 'bold' : 'normal',
                  'border-radius': (channel.channelId || channel.name) === activeChannel ? '6px' : '0px'
                }">
                  <span>
                    <img src="assets/community-channel.svg"
                      *ngIf="channel.channelVisibility === 'private' && !channel.isOpenForTeamMembers" />
                    <img src="assets/public-channel.svg"
                      *ngIf="channel.channelVisibility === 'private' && channel.isOpenForTeamMembers" />
                    {{ channel.channelName || channel.name }}
                  </span>

                  <span class="unread-count pt-2px plr-15 fs-13 dynamic-font" [ngStyle]="{
                    'background-color': (channel.channelId || channel.name) === activeChannel
                      ?  settingsData?.space_button_secondary_color 
                      :  settingsData?.space_bg_primary_color,
                    'color': (channel.channelId || channel.name) === activeChannel
                      ? settingsData?.space_button_font_secondary_color
                      : settingsData?.space_font_primary_color,
                      'font-family': settingsData?.font_family
                  }" *ngIf="unreadCount[channel?.channelUrl]">{{ unreadCount[channel?.channelUrl] > 99 ? '99+' : unreadCount[channel?.channelUrl] }}</span>
                </li>
              </ng-container>
            </ng-container>
          </ng-container>
        </ul>

        <!-- Horizontal Line -->
        <div class="horizontal-line" *ngIf="getSectionChannels(section)"
          [ngStyle]="{ 'background-color': settingsData?.space_bg_primary_color }"></div>
      </div>
    </div>
  </div>


  <div class="back-btn-wrap">
    <button class="back-btn" (click)="headBackToNetwork()" [ngStyle]="{
      'background-color': settingsData?.space_button_primary_color ? settingsData?.space_button_primary_color : settingsData?.bg_tertiary_color,
      'color': settingsData?.space_button_font_primary_color,
      'font-size': settingsData?.fs_sentence,
      'border':'1px solid' + settingsData?.space_button_secondary_color,
      'font-family': settingsData?.font_family
    }">
      Head back to Network
    </button>
  </div>

</div>